import React from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';

const columns = ({
  setExtraPaymentDetailsData,
  setIsExtraPaymentDetailsOpen,
}: {
  setExtraPaymentDetailsData: any;
  setIsExtraPaymentDetailsOpen: any;
}) => {
  return [
    {
      name: 'Name',
      grow: 2,
      cell: (row: any) => (
        <div
          className="d-flex align-items-center"
          style={{
            cursor: 'pointer',
            transition: 'filter 0.3s ease',
            filter: 'brightness(1)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(0.8)')}
          onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
          onClick={() => {
            setExtraPaymentDetailsData(row);
            setIsExtraPaymentDetailsOpen(true);
          }}
        >
          <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
            <img
              src={row.user.picture}
              alt="User Profile"
              className="img-fluid"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <span className="ml-2 text-primary font-weight-bold text-sm">{`${row.user.firstName || '-'} ${
            row.user.lastName || '-'
          }`}</span>
        </div>
      ),
    },
    {
      name: 'Type',
      selector: (row: any) => row.type,
      grow: 1,
      cell: (row: any) => row.type,
    },
    {
      name: 'Pay Amount',
      selector: (row: any) => (row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : ''),
      grow: 1,
      cell: (row: any) => (row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : ''),
    },
    {
      name: 'Date Added To Payroll',
      selector: (row: any) => (row.dateAddingToPayroll ? moment(row.dateAddingToPayroll).format('MMMM D, YYYY') : ''),
      grow: 2,
      cell: (row: any) => (row.dateAddingToPayroll ? moment(row.dateAddingToPayroll).format('MMMM D, YYYY') : ''),
    },
    {
      name: 'Documentation',
      selector: () => (
        <div className="d-flex">
          <Button
            style={{
              border: 'none',
              boxShadow: 'none',
              background: '#FFFFFF',
              padding: 0,
            }}
          >
            <i className="fas fa-download" />
          </Button>
        </div>
      ),
      grow: 1,
      cell: (row: any) => (
        <div className="d-flex">
          {(row.type === 'Health Care' || row.type === 'Reimbursement') && (
            <Button
              style={{
                border: 'none',
                boxShadow: 'none',
                background: '#FFFFFF',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                transition: 'filter 0.3s ease',
                filter: 'brightness(1)',
                color: '#416adb',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(1.2)')}
              onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
            >
              <a href={row.document} target="_blank" className="d-flex flex-column align-items-center">
                <i className="fas fa-download" />
                <span style={{ fontSize: 11, fontWeight: 'normal' }}>Document</span>
              </a>
            </Button>
          )}
          {row.type === 'Reimbursement' && (
            <Button
              style={{
                border: 'none',
                boxShadow: 'none',
                background: '#FFFFFF',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                transition: 'filter 0.3s ease',
                filter: 'brightness(1)',
                color: '#416adb',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(1.2)')}
              onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
            >
              <a href={row.receipt} target="_blank" className="d-flex flex-column align-items-center">
                <i className="fas fa-download" />
                <span style={{ fontSize: 11, fontWeight: 'normal' }}>Receipt</span>
              </a>
            </Button>
          )}
        </div>
      ),
    },
    {
      name: 'View',
      selector: (row: any) => row.supervisor.name,
      grow: 0,
      cell: (row: any) => (
        <div className="d-flex">
          <Button
            style={{
              border: 'none',
              boxShadow: 'none',
              background: '#FFFFFF',
              padding: 0,
            }}
            onClick={() => {
              setExtraPaymentDetailsData(row);
              setIsExtraPaymentDetailsOpen(true);
            }}
          >
            <i className="fas fa-eye" />
          </Button>
        </div>
      ),
    },
  ];
};

export default columns;
